import Sosimtech from './assets/sosimtech-removebg-preview.png'
import EazyErp from './assets/Eazyerp-logo-removebg-preview.png'

const experiencedata = [
    {
        "id": 1,
        "name": "EazyErp Technologies Pvt. Ltd.", 
        "alt": "EazyErp",
        "content": "Eazy Business Solutions is a leading provider of innovative enterprise level IT Solutions like ERP, CRM, DMS, Asset Management, Payroll & other customized.",
        "img": EazyErp,
        "time": "May-2023 TO PRESENT"
    },
    {
        "id": 2,
        "name": "Sosimtech Technologies Pvt. Ltd.",
        "alt": "Sosimtech",
        "content": "Solution made a Simple.",
        "img": Sosimtech,
        "time": "Feb-2022 TO Apr-2023"
    }    
]

export default experiencedata;